<template>
  <div>
    <ContentLoader
      :height="154"
      :width="470"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      class="transform-scale-0"
    >
      <rect x="0" y="4" rx="5" ry="5" width="146" height="130" />
      <rect x="156" y="4" rx="5" ry="5" width="146" height="130" />
      <rect x="312" y="6" rx="5" ry="5" width="146" height="130" />
    </ContentLoader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'ContentLoadingTwoGrid',
  components: {
    ContentLoader,
  },
};
</script>

<style>

</style>
